import { Component, OnInit, Input } from '@angular/core';
import { SideMenuService } from './../side-menu/side-menu.service';

@Component({
  selector: 'yt-fw-app-content',
  templateUrl: './app-content.component.html',
  styleUrls: ['./app-content.component.scss']
})
export class AppContentComponent implements OnInit {

  constructor(private sideMenuService: SideMenuService) { }

  appContentCollapsed: boolean = false;

  @Input() CollapseWhenMenuVisible: boolean = true;

  ngOnInit() {
    this.sideMenuService.SideMenuCollapsed
      .subscribe(value => {
        this.appContentCollapsed = this.CollapseWhenMenuVisible && !value;
      })
  }

}
